import type { VillageReferenceRecord, VillageSummary, VillageViewModel } from "../domain/contracts";
import { toVillageViewModel } from "./viewModels";

export function buildPreviewVillageViewModels(villages: VillageSummary[], reference: VillageReferenceRecord[]): VillageViewModel[] {
  return villages
    .map((village) => toVillageViewModel(village, reference))
    .sort((left, right) => left.title.localeCompare(right.title));
}

export function buildMapVillagePoints(villages: VillageSummary[], reference: VillageReferenceRecord[]): VillageViewModel[] {
  const previewVillagePoints = buildPreviewVillageViewModels(villages, reference);
  const matchedReferenceIds = new Set(
    previewVillagePoints
      .map((village) => village.reference?.id ?? null)
      .filter((referenceId): referenceId is string => Boolean(referenceId)),
  );

  const referenceOnlyPoints = reference
    .filter((referenceRecord) => !matchedReferenceIds.has(referenceRecord.id))
    .map((referenceRecord) => ({
      id: referenceRecord.id,
      slug: referenceRecord.slug,
      backendRef: null,
      dataSource: "reference-only" as const,
      title: referenceRecord.title,
      township: referenceRecord.township || "unknown",
      coordinates: {
        lat: referenceRecord.lat,
        lng: referenceRecord.lng,
      },
      stats: emptyStats(),
      availability: {
        sitesGallery: false,
        satellite: false,
        interviewees: false,
      },
      updatedAt: referenceRecord.dateAdded || referenceRecord.published || "",
      publishVersion: referenceRecord.template || "csv-reference",
      reference: referenceRecord,
    }));

  return [...previewVillagePoints, ...referenceOnlyPoints].sort((left, right) => left.title.localeCompare(right.title));
}

function emptyStats(): VillageSummary["stats"] {
  return {
    interviewCount: 0,
    officialDocumentCount: 0,
    survivorAccountCount: 0,
    reportedDeceasedCount: 0,
    reportedMissingCount: 0,
    siteMediaCount: 0,
    massGraveEvidenceCount: 0,
    evidenceItemCount: 0,
  };
}
